import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import userPic from "../assets/images/user.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getParentProfile, resendEmailVerfication, updateParentProfile } from '../services/ProfileApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';
import defaultProfile from "../assets/images/default-profile.png";
import config from '../config/config';

const ParentProfile = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [parentData, setParentData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    date_of_birth: null,
    profile_image: null,
    previewImage: defaultProfile
  });
  const [loading, setLoading] = useState(true);
  const emailVerifiedAt = user.email_verified_at || null;

  useEffect(() => {
    fetchParentProfile();
  }, []);

  const fetchParentProfile = async () => {
    try {
      const response = await getParentProfile(user.id);
      setParentData({
        name: response.name,
        email: response.email,
        mobile_number: response.mobile_number,
        date_of_birth: response.date_of_birth ? new Date(response.date_of_birth) : null,
        profile_image: response.profile_pic_url || null,
        previewImage: response.profile_pic_url ? `${config.Image_Base_URL}${response.profile_pic_url}` : defaultProfile
      });
      // showToast("Profile data fetched successfully!", "success");
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setParentData({ ...parentData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (date) => {
    setParentData({ ...parentData, date_of_birth: date });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setParentData({ ...parentData, profile_image: file, previewImage: URL.createObjectURL(file) });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", parentData.name);
    formData.append("email", parentData.email);
    formData.append("mobile_number", parentData.mobile_number);
    formData.append("date_of_birth", parentData.date_of_birth ? parentData.date_of_birth.toISOString().split("T")[0] : "");
    if (parentData.profile_image && typeof parentData.profile_image !== "string") {
      formData.append("profile_image", parentData.profile_image);
    }

    try {
      await updateParentProfile(user.id, formData);
      showToast("Profile updated successfully!", "success");
      fetchParentProfile();
    } catch (error) {
      showToast("Failed to update profile", "error");
    }
  };

  const resendVerificationEmail = async () => {
    const payload = { 'email': user.email };
    try {
      const response = await resendEmailVerfication(payload);
      if (response) {
        showToast("Verification email resent.", "success");
      }
    } catch (error) {
      showToast("Failed to send. please try later!", "error");
    }
  }

  if (loading) return <LoadingSpinner />;
  const tooltip = (
    <Tooltip id="tooltip">
      Click Here to verify your email
    </Tooltip>
  );

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>

        <Form className='fs-12' onSubmit={handleSubmit}>
          <div className='AccountInnerMain d-flex align-items-center justify-content-between'>
            <h6>
              <img src={userPic} width={20} alt="user" />
              <span className='ps-1'> Parent Profile</span>
            </h6>
            <div className='uploadPic'>
              <div className='photo text-center'>
                <label htmlFor="file-upload" className='image_profile bg_dark_blue custom-file-upload'>
                  <img src={parentData.previewImage} alt="Profile Preview" />
                </label>
                <input id="file-upload" type="file" onChange={handleFileChange} />
                <p className='mb-0 fs-10'>Upload Photo</p>
              </div>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Parent Name</Form.Label>
            <Form.Control type="text" name="name" className='border-2 fs-14' value={parentData.name} onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control type="text" name="mobile_number" className='border-2 fs-14' value={parentData.mobile_number} onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Id</Form.Label>
            {emailVerifiedAt === null ?
              <OverlayTrigger placement="right" overlay={tooltip}>
                <Button className='ms-2 px-2 py-0 m-0 fs-10 rounded-3' variant="warning" size='sm' onClick={resendVerificationEmail}>Verify Pending</Button>
              </OverlayTrigger>
              :
              <span className='badge bg-success fs-10 ms-2'>successfully Verified</span>
            }

            <Form.Control type="email" name="email" className='border-2 fs-14' value={parentData.email} readOnly disabled />
          </Form.Group>

          <Form.Group className="mb-3 datePicker">
            <Form.Label className='d-block'>Date Of Birth</Form.Label>
            <DatePicker
              selected={parentData.date_of_birth}
              onChange={handleDateChange}
              dateFormat="dd MMM, yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              className="form-control border-2 w-100 fs-14"
              placeholderText="Select Date of Birth"
              isClearable
            />
          </Form.Group>

          <Form.Group className='d-flex justify-content-between'>
            <Button variant="danger" size='sm' type="submit" className='px-3 rounded-5 text-white'>
              Submit
            </Button>
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
};

export default ParentProfile;
